var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupermarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "delapouite-shop-gradient-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.18 21C232.938 21 209.603 24.01 192.994 29.54C184.69 32.303 178.126 35.736 174.186 39.098C170.246 42.458 169.019 45.054 169 48.058L168.943 57L41 57L41 71L471 71L471 57L342.967 57L343 47.967C343.01 44.965 341.83 42.417 337.943 39.072C334.056 35.728 327.536 32.299 319.266 29.537C302.724 24.014 279.42 21 256.18 21Z",
    className: "selected",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.277 89L27.834 183L108.734 183L128.977 96.64L122.81 183L203.88 183L220.994 96.32L217.898 183L293.648 183L289.014 96.482L307.694 183L389.191 183L383.024 96.64L403.266 183L484.166 183L473.723 89L38.277 89Z",
    className: "",
    fill: "#48baff",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.834 201L25.324 205.588C39.822 226.445 52.968 235 64 235C75.32 235 88.852 226.11 103.8 204.04L104.514 201L25.834 201Z",
    className: "",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.521 201L121.201 205.498C135.753 226.495 148.935 235 160 235C171.293 235 184.788 226.15 199.693 204.197L200.323 201L121.521 201Z",
    className: "",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.257 201L217.101 205.352C231.69 226.455 244.908 235 256 235C267.08 235 280.28 226.475 294.85 205.424L294.613 201L217.256 201Z",
    className: "",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.581 201L312.255 204.12C327.255 226.312 340.758 235.164 352.028 235.133C363.058 235.103 376.24 226.513 390.8 205.496L390.48 201L311.58 201Z",
    className: "",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.487 201L408.2 204.04C423.147 226.11 436.68 235 448 235C459.032 235 472.178 226.445 486.676 205.588L486.166 201L407.486 201Z",
    className: "",
    fill: "#f8e71c",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 223.31C97.313 242.11 81.492 253 64 253C50.028 253 37.116 246.094 25 233.736L25 487L343 487L343 279L457 279L457 487L487 487L487 233.736C474.884 246.094 461.972 253 448 253C430.51 253 414.69 242.112 400.004 223.316C385.34 242.124 369.572 253.086 352.078 253.133C334.57 253.181 318.726 242.263 303.986 223.326C289.303 242.116 273.486 253 256 253C238.508 253 222.687 242.11 208 223.31C193.313 242.11 177.492 253 160 253C142.508 253 126.687 242.11 112 223.31Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 279L313 279L313 457L55 457L55 279Z",
    className: "",
    fill: "#9b9b9b",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 297L73 439L295 439L295 297L73 297Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 297L361 368.064L439 368.637L439 297L361 297Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 312L216 312C107.765 320 99.69 336 88 425.11L88 312Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 386.066L361 400.064L439 400.637L439 386.635L361 386.065Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 418.066L361 487L439 487L439 418.635L361 418.065Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarket);
export default __webpack_public_path__ + "static/media/Supermarket.9f4a83d268a46c4c9486d6899a3ce0f8.svg";
export { ForwardRef as ReactComponent };